import { FelaCSS, FelaCSSWithCustomSelectors, colors } from '@bridebook/ui';

interface IStyleProps {
  minified?: boolean;
  fullBleed?: boolean;
}

interface IStyles {
  wrapper: FelaCSS;
  infoWrap: FelaCSS;
  name: FelaCSS;
  secondaryInfoWrap: FelaCSSWithCustomSelectors;
  ratingWrap: FelaCSS;
  availableInfoNote: FelaCSS;
  reviewAmount: FelaCSS;
  fullBleedWrapper: FelaCSS;
  supplierName: FelaCSS;
}

const styles = ({ minified, fullBleed }: IStyleProps): IStyles => ({
  wrapper: {
    paddingLeft: '10px',
    paddingRight: '10px',
    paddingTop: minified ? '4px' : '10px',
    paddingBottom: minified ? '9px' : '10px',
    height: minified ? '52px' : undefined,
    backgroundColor: colors.white,
  },

  fullBleedWrapper: {
    position: 'absolute',
    bottom: 0,
    backgroundColor: 'transparent',
    paddingLeft: 4,
    paddingBottom: 4,
    maxWidth: '80%',

    maxWidthTabletSm: {
      paddingLeft: 3,
      paddingBottom: 3,
    },
  },

  infoWrap: {
    flexGrow: 1,
    alignItems: 'flex-start',
    minHeight: fullBleed ? 0 : '28px',
  },

  name: {
    display: 'block',
    marginBottom: fullBleed ? 0 : minified ? '6px' : '4px',
    fontDefaultSemiBold: 16,
    lineHeight: '16px',
    color: fullBleed ? colors.white : colors.space,
  },

  secondaryInfoWrap: {
    flexDirection: 'row',
    alignItems: 'center',

    '> :not(:first-child)': {
      display: 'flex',
      flexDirection: 'row',

      ':before': {
        marginLeft: '6px',
        marginRight: '6px',
        content: '"•"',
      },
    },
  },

  ratingWrap: {
    flexShrink: 0,
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: fullBleed ? 0 : '10px',
  },

  availableInfoNote: {
    fontDefault: 12,
    color: colors.space60,
    marginBottom: '10px',
  },

  reviewAmount: {
    marginLeft: '3px',
    fontDefault: 12,
    lineHeight: '14px',
    color: fullBleed ? colors.white : colors.space60,
  },

  supplierName: {
    color: colors.white,
    textAlign: 'left',
  },
});

export default styles;
